"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_DOMAIN_KEY = exports.UP_KEY = exports.TAB_KEY = exports.STATUS_PAGE_LINK = exports.NOOP = exports.INSIGHTS_LINK = exports.HELP_LINK = exports.FORWARD_SLASH_KEY = exports.FEEDBACK_LINK = exports.ESCAPE_KEY = exports.ENTER_KEY = exports.EMAIL_REGEX = exports.DOWN_KEY = exports.DEV_PORTAL_LINK = exports.DELETE_KEY = exports.DATETIME_FORMAT_TIME = exports.DATETIME_FORMAT_FULL = exports.DATETIME_FORMAT_DATE = exports.CONSOLE_LINK = exports.BACKSPACE_KEY = exports.AU_ACCOUNT_ID = void 0;
const NOOP = () => {};
exports.NOOP = NOOP;
const DATETIME_FORMAT_TIME = 'HH:mm z';
exports.DATETIME_FORMAT_TIME = DATETIME_FORMAT_TIME;
const DATETIME_FORMAT_DATE = 'MMM dd yyyy';
exports.DATETIME_FORMAT_DATE = DATETIME_FORMAT_DATE;
const DATETIME_FORMAT_FULL = `${DATETIME_FORMAT_DATE} ${DATETIME_FORMAT_TIME}`;
exports.DATETIME_FORMAT_FULL = DATETIME_FORMAT_FULL;
const USER_DOMAIN_KEY = 'auUserDomain';
exports.USER_DOMAIN_KEY = USER_DOMAIN_KEY;
const EMAIL_REGEX = /^(\w.+@){0,1}((?:[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]{0,61}\.)+[a-zA-Z]{2,})$/;
exports.EMAIL_REGEX = EMAIL_REGEX;
const AU_ACCOUNT_ID = "79000000-0000-0000-0000-000000000000";
exports.AU_ACCOUNT_ID = AU_ACCOUNT_ID;
const TAB_KEY = 'Tab';
exports.TAB_KEY = TAB_KEY;
const ENTER_KEY = 'Enter';
exports.ENTER_KEY = ENTER_KEY;
const UP_KEY = 'ArrowUp';
exports.UP_KEY = UP_KEY;
const DOWN_KEY = 'ArrowDown';
exports.DOWN_KEY = DOWN_KEY;
const ESCAPE_KEY = 'Escape';
exports.ESCAPE_KEY = ESCAPE_KEY;
const BACKSPACE_KEY = 'Backspace';
exports.BACKSPACE_KEY = BACKSPACE_KEY;
const DELETE_KEY = 'Delete';
exports.DELETE_KEY = DELETE_KEY;
const FORWARD_SLASH_KEY = '/';
exports.FORWARD_SLASH_KEY = FORWARD_SLASH_KEY;
const DEV_PORTAL_LINK = 'devportal-link';
exports.DEV_PORTAL_LINK = DEV_PORTAL_LINK;
const FEEDBACK_LINK = 'feedback-link';
exports.FEEDBACK_LINK = FEEDBACK_LINK;
const HELP_LINK = 'help-link';
exports.HELP_LINK = HELP_LINK;
const INSIGHTS_LINK = 'insights-link';
exports.INSIGHTS_LINK = INSIGHTS_LINK;
const CONSOLE_LINK = 'console-link';
exports.CONSOLE_LINK = CONSOLE_LINK;
const STATUS_PAGE_LINK = 'status-page-link';
exports.STATUS_PAGE_LINK = STATUS_PAGE_LINK;